var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedbackActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7119 1.7143C9.90357 1.71486 8.12925 2.2059 6.57793 3.13513C5.02662 4.06435 3.75639 5.39696 2.90255 6.99101C2.0487 8.58506 1.64322 10.3809 1.72928 12.1871C1.81535 13.9934 2.38974 15.7425 3.39127 17.2482L1.71484 21.7084L7.32857 20.6933C8.68034 21.3539 10.1638 21.7008 11.6683 21.7083C13.1728 21.7157 14.6596 21.3835 16.0178 20.7363C17.3761 20.0892 18.5707 19.1438 19.5128 17.9707C20.4548 16.7976 21.1199 15.427 21.4584 13.961C21.797 12.4951 21.8003 10.9716 21.4682 9.50419C21.136 8.03678 20.4769 6.66328 19.54 5.48605C18.6031 4.30883 17.4126 3.35825 16.0572 2.70519C14.7018 2.05212 13.2164 1.71341 11.7119 1.7143V1.7143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedbackActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback_active.f1ff7e5a7a0553885b7cb3e488b87a36.svg";